import { Modal } from "@components/modal";
import { Box, Button, Grid, IconButton, Typography } from "@material-ui/core";
import { Delete as DeleteIcon, Edit as EditIcon } from "@material-ui/icons";
import { Application } from "@store/types";
import { TEXTS } from "@utils";
import React from "react";
import { useHistory } from "react-router";
import { Actions, Header, Section, Table } from "../../../../components";
import { Access, System, useRequestContext } from "../../../../context";
import { EditModal } from "../../../summary/views/summary/access-list/edit-modal";
import { SelectedSystem } from "../../../summary/views/summary/access-list";
import { postDraft } from "@api/drafts";
import { getDraftPayloadValuesFromRequestContext } from "../../../../utils";
import { SaveDraftModal } from "../../../other-components/saveDraftModal";

export const SystemsList: React.FC = () => {
  const [requestContextState, requestContextDispatch] = useRequestContext();

  // [TODO] Review this
  const [openModalDraft, setOpenModalDraft] = React.useState<boolean>(false);
  const [selectedSystem, setSelectedSystem] = React.useState<
    SelectedSystem | undefined
  >(undefined);
  const [open, setOpen] = React.useState<boolean>(false);

  const history = useHistory();
  const actions = [
    {
      label: "Cancel",
      handler: () => {
        setOpenModalDraft(false);
      },
    },
    {
      label: "Yes",
      handler: () => {
        postDraft(
          getDraftPayloadValuesFromRequestContext(requestContextState.values)
        ).then(() => {
          history.push("/dashboard/drafts");
        });
      },
    },
  ];

  function handleClose() {
    setOpen(false);
    setSelectedSystem(undefined);
  }

  let editModal = null;
  if (!!selectedSystem) {
    editModal = (
      <EditModal
        open={open}
        selectedSystem={selectedSystem}
        onSubmit={(details: System, error: boolean) => {}}
        onClose={handleClose}
      />
    );
  }

  // Handlers

  function handleAddMoreSystemButtonClick(): void {
    requestContextDispatch({
      type: "set-step",
      name: "system-details",
      view: "select-systems",
    });
  }

  function handleUpdateAccessButtonClick(system: System, access: Access): void {
    setOpen(true);
    setSelectedSystem({ system, access });
  }

  function handleDeleteAccessButtonClick(system: System, access: Access): void {
    requestContextDispatch({
      type: "remove-system-access",
      system,
      access,
    });
    // if (check_if_systems_list_is_empty) {
    //   requestContextDispatch({
    //     type: "set-step",
    //     name: "system-details",
    //     view: "select-systems",
    //   });
    // }
  }

  function handlePreviousButtonClick(): void {
    requestContextDispatch({
      type: "set-step",
      name: "system-details",
      view: "select-systems",
    });
  }

  function handleSaveAsDraftButtonClick(): void {
    setOpenModalDraft(true); // [TODO] Refactor
  }

  function handleNextButtonClick(): void {
    requestContextDispatch({
      type: "set-step",
      name: "summary",
      view: "summary",
    });
  }

  // Helpers

  function isSectionActive(): boolean {
    return (
      requestContextState.step.name === "system-details" &&
      requestContextState.step.view === "systems-list"
    );
  }

  function getRowKey(application: Application, access: Access): string {
    return `${application.id}:${access.environment?.name}:${access.role?.name}`;
  }

  function isNextButtonDisabled(): boolean {
    return !requestContextState.values.systems.length;
  }

  const closeSaveDraftModal = () => {
    setOpenModalDraft(false);
  };

  return (
    <Section active={isSectionActive()}>
      <Grid container spacing={2} component={Box} pb={2}>
        <Grid item xs={12}>
          <Header title="Systems Confirmation">
            <Button variant="outlined" onClick={handleAddMoreSystemButtonClick}>
              + Add more systems
            </Button>
          </Header>
        </Grid>
      </Grid>
      <Grid
        container
        spacing={2}
        component={Box}
        flexGrow={1}
        overflow="hidden"
      >
        <Grid item xs={12} component={Box} display="flex" height="100%">
          <Table
            columns={[
              {
                label: "Application / Device Type / Domain Account",
              },
              { label: "Domain / Host", width: "160px" },
              { label: "Environment", width: "100px" },
              { label: "Role", width: "100px" },
              { label: "Edit", width: "65px" },
              { label: "Remove", width: "80px" },
            ]}
            rowHeight={43}
          >
            {requestContextState.values.systems.map((system) =>
              system.accesses.map((access) => (
                <Table.Row key={getRowKey(system.application, access)}>
                  <Table.Cell>{system.application.name}</Table.Cell>
                  <Table.Cell>{system.application.host}</Table.Cell>
                  <Table.Cell>
                    {access.environment ? access.environment?.name : "N/A"}
                  </Table.Cell>
                  <Table.Cell>{access.role?.name}</Table.Cell>
                  <Table.Cell index={4} align="center">
                    <IconButton
                      size="small"
                      onClick={() =>
                        handleUpdateAccessButtonClick(system, access)
                      }
                    >
                      <EditIcon fontSize="small" />
                    </IconButton>
                  </Table.Cell>
                  <Table.Cell index={5} align="center">
                    <IconButton
                      size="small"
                      onClick={() =>
                        handleDeleteAccessButtonClick(system, access)
                      }
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Table.Cell>
                </Table.Row>
              ))
            )}
          </Table>
        </Grid>
      </Grid>
      <Grid container spacing={2} component={Box} pt={2}>
        <Grid item xs={12}>
          <Actions>
            <Actions.Cancel />
            <Actions.Previous onClick={handlePreviousButtonClick} />
            <Actions.SaveAsDraft onClick={handleSaveAsDraftButtonClick} />
            <Actions.Next
              disabled={isNextButtonDisabled()}
              onClick={handleNextButtonClick}
            />
          </Actions>
        </Grid>
      </Grid>
      <SaveDraftModal
        isShowDraft={openModalDraft}
        data={requestContextState.values}
        closeSaveDraftModal={closeSaveDraftModal}
      />
      {editModal}
    </Section>
  );
};
